import {useState} from 'react';

const useProgressState = () => {
  const [success, setSuccess] = useState<boolean>(false);

  const [failure, setFailure] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [btnLoading, setBtnLoading] = useState<boolean>(false);

  return {
    setDefault: () => {
      setSuccess(false);
      setFailure(false);
      setLoading(false);
      setBtnLoading(false);
    },
    setSuccess: () => {
      setSuccess(true);
      setFailure(false);
      setLoading(false);
      setBtnLoading(false);
    },
    setFailure: () => {
      setFailure(true);
      setSuccess(false);
      setLoading(false);
      setBtnLoading(false);
    },
    setLoading: () => {
      setFailure(false);
      setSuccess(false);
      setLoading(true);
      setBtnLoading(false);
    },
    setBtnLoading: () => {
      setFailure(false);
      setSuccess(false);
      setLoading(false);
      setBtnLoading(true);
    },
    success,
    failure,
    btnLoading,
    loading,
  };
};

export default useProgressState;
